import type { NextPage } from "next";

import { keystoneContext } from "@edwt/frontend/lib/keystone";

import { DocumentRenderer } from "~/components/ui/DocumentRenderer";

import type { ResourcesPage } from ".prisma/client";
import Layout from "~/components/layout/DefaultLayout";
import { env } from "~/env";

/**
 * https://nextjs.org/docs/pages/building-your-application/data-fetching/get-static-props
 */
export async function getStaticProps() {
  if (process.env.BUILDING)
    return {
      notFound: true,
    };

  console.log("⚙️ Generating static page for Resources route ('/resources')");

  const resources = await keystoneContext.prisma.resourcesPage.findFirst();

  return {
    props: {
      resources,
    },
    revalidate: env.REVALIDATE_PAGE_TIME_MINUTES * 60,
  };
}

/**
 * Simple auxiliary resources page that renders rich text field from CMS
 */
const Resources: NextPage<{ resources: ResourcesPage }> = ({ resources }) => {
  return (
    <Layout pageTitle="Resources">
      <h1 className="mb-10 text-2xl">{resources?.title}</h1>
      <article className="prose">
        {resources && resources.document ? (
          /* @ts-ignore */
          <DocumentRenderer document={resources.document} />
        ) : (
          false
        )}
      </article>
    </Layout>
  );
};

export default Resources;
